import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { keys } from './keys';
import type { QueryOptions } from './query-client';
import { request } from './client';
import type { StatusReport } from './types';

/** /status: the dependency probes the API runs against itself (admin only). */
export const statusApi = {
  current: () => request<StatusReport>('/status'),
  check: () => request<StatusReport>('/status/check', { method: 'POST' }),
};

/** The report the API has cached; refetched every minute while the page is open. */
export function useStatus(options: QueryOptions = {}) {
  return useQuery({
    queryKey: keys.status.current,
    queryFn: statusApi.current,
    refetchInterval: 60_000,
    ...options,
  });
}

/** Runs every probe fresh; the answer replaces the cached report at once. */
export function useRunStatusCheck() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: statusApi.check,
    onSuccess: (report) => queryClient.setQueryData(keys.status.current, report),
  });
}
